import { Flow } from 'signup-constants/Flow';
import { SignupEmbedder } from 'signup-embedder';
import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { isEnglishLanguage } from '../i18n/LanguageUtils';
import { getApplicationLocale } from '../i18n/LocaleUtils';
import { getFlowKey } from '../routing/getFlowKey';
import { Data } from '../signup-data/DATA';
import { getShowProductSetupUIBranch, isSoftwareSignup } from '../store/flow/selectors';
import { getIsMobile } from '../utils/deviceUtils';
import { getHasHubsSignupUrlParamForACQ111 } from './acq111/acq111Utils';
import { enrollOnFlow } from './experimentDefaults';
import { ExperimentKeys, TEST_KEY } from './ExperimentKeys';
import { getIsNewUserExperiment } from './ExperimentUtils';
export const EXPERIMENT_ID = 'experimentId';
const SEEN_EXPERIMENTS = new Set();
const Experiments = new Map([[ExperimentKeys.ONBF016_RELEASE, {
  shouldEnroll: () => {
    const isCrmFlow = [Flow.Crm].includes(getFlowKey());
    return isCrmFlow;
  }
}], [ExperimentKeys.BIAB001, {
  shouldEnroll: state => {
    return getFlowKey() === Flow.Crm && getApplicationLocale() === Locale.en && state.signupData[Data.Industry].value === 'marketing-and-advertising';
  }
}], [ExperimentKeys.ACQ123, {
  shouldEnroll: state => {
    const isCorrectFlow = [Flow.Crm, Flow.Sales, Flow.Service, Flow.Marketing].includes(getFlowKey());
    const isNewUser = getIsNewUserExperiment(state);
    const hasHubsSignupUrlParamForACQ111 = getHasHubsSignupUrlParamForACQ111();
    return isCorrectFlow && isNewUser && !hasHubsSignupUrlParamForACQ111;
  }
}], [ExperimentKeys.ACQ124, {
  shouldEnroll: state => {
    const isCorrectFlow = isSoftwareSignup();
    const isNewUser = getIsNewUserExperiment(state);
    const hasHubsSignupUrlParamForACQ111 = getHasHubsSignupUrlParamForACQ111();
    return isCorrectFlow && isNewUser && !hasHubsSignupUrlParamForACQ111;
  }
}], [ExperimentKeys.ONBC008, {
  shouldEnroll: state => {
    return getShowProductSetupUIBranch(state);
  }
}], [ExperimentKeys.ACQ127, {
  shouldEnroll: state => {
    const isMobile = getIsMobile();
    const isNewUser = getIsNewUserExperiment(state);
    return !isMobile && isNewUser && getFlowKey() === Flow.Academy && isEnglishLanguage() && !SignupEmbedder.isActive();
  }
}], [ExperimentKeys.ACQ125, {
  shouldEnroll: state => {
    const isNewUser = getIsNewUserExperiment(state);
    const isCorrectFlow = [Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service].includes(getFlowKey());
    return isNewUser && isCorrectFlow;
  }
}], [ExperimentKeys.ACQ126, {
  shouldEnroll: state => {
    const isNewUser = getIsNewUserExperiment(state);
    const isCorrectFlow = [Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service].includes(getFlowKey());
    return isNewUser && isCorrectFlow;
  }
}]]);
export const getExperiment = id => {
  // we want to prefer this solution over mocking getExperiment so that the
  // seen experiments tracking below continues to work and doesn't get
  // accidentally mocked
  if (id === TEST_KEY) {
    return {
      shouldEnroll: () => enrollOnFlow([Flow.Crm])
    };
  }

  SEEN_EXPERIMENTS.add(id);
  return Experiments.get(id);
};
export function getSeenExperimentsForTesting() {
  return Array.from(SEEN_EXPERIMENTS);
}